/* eslint-disable */
import { observe, action, observable } from 'mobx'
import axios from 'axios'

import Auth from './Auth'

import config from '../config'

class Motd {
  @observable all = {}

  @action
  postMotd = comId => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/motd/${comId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.all = {
          ...this.all,
          [comId]: {
            ...res.data.data,
            statusCode: res.status
          }
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchMotd = (comId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/motd/${comId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        this.all = {
          ...this.all,
          [comId]: {
            ...this.all[comId],
            [field]: value
          }
        }

        return this.all[comId]
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getMotd = comId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/motd/${comId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.all = {
          ...this.all,
          [comId]: {
            ...res.data.data,
            statusCode: res.status
          }
        }

        return res.data.data
      })
      .catch(e => {
        this.all = {
          ...this.all,
          [comId]: {
            statusCode: e.response.status
          }
        }

        console.warn(e)
      })
  }

  @action
  renderAll = () => {
    return axios({
      method: `post`,
      url: `${config.api_uri}/motd/render`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    }).catch(e => console.warn(e))
  }
}

export default new Motd()



// WEBPACK FOOTER //
// ./src/stores/Motd.js